window.am = window.am || {};

window.am.personioTracking = new function () {
  const trackingKeyBase = 'am_karriere'

  const init = () => {
    const links = document.querySelectorAll('.personio-jobsad-main .link-button, .personio-jobsad-main .link-item')

    links.forEach((link) => {
      link.addEventListener('click', click);
    })
  };

  const click = (e) => {
    const key = e.currentTarget.dataset.trackingKey || e.currentTarget.innerText;
    const isButton = e.currentTarget.classList.contains('link-button');
    const linkKey = isButton ? 'button' : 'link';
    const fullKey = `${trackingKeyBase}_${linkKey}_${key}`;

    if (typeof utag != 'undefined' &&
        typeof utag.link != 'undefined') {
      utag.link({
        etracker_event_action: "click",
        event_id: fullKey,
      });
    }
  };
  
  return {
    init: init
  };
};

window.addEventListener('load', window.am.personioTracking.init);